import { TestiMonials } from "./Containt_home";
import SignUp from "./SignUp";

import React from "react";

const Login = ()=>{
    return <div>
   <div> <SignUp/></div>
    <TestiMonials />;
    </div>
}
export default Login;